var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","pa-0":""}},[_c('v-flex',{staticClass:"summary-view-container"},[_c('BookingSummaryDetail')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }